import React from 'react';
import { useNavigate } from 'react-router-dom';
import TitleActionLine from './title_action_line';

import StandardBoxList from './standard_box_list';
import TextButton from './buttons/text_button';
import PropList from './prop_list';

import DownloadHelper from '../lib/download_helper';
import type { Item } from '../lib/download_helper';

import { byteFormat } from '../tools/util';

export default function DownloadProgress(props) {
  const { path, mediaGrant } = props;
  const navigate = useNavigate();
  const list = DownloadHelper.useList();
  const summary = DownloadHelper.useSummary();

  function _onClosePress() {
    navigate(`/home/${mediaGrant?.grant_name}${path}`);
  }

  let status = '';
  let detail = '';
  let success = '';
  let failure = '';
  let skipped = '';
  if (summary) {
    const { file_count, success_count, fail_count, skip_count } = summary;
    const { total_size, success_size, fail_size, skip_size } = summary;

    if (summary.is_running) {
      status = 'Running';
    } else {
      status = fail_count > 0 ? `Done - ${fail_count} Failed` : 'Success';
    }
    detail = `${file_count} Total, ${byteFormat(total_size)}`;
    success = `${success_count} files, ${byteFormat(success_size)}`;
    failure = `${fail_count} files, ${byteFormat(fail_size)}`;
    skipped = `${skip_count} files, ${byteFormat(skip_size)}`;
  }

  let button: any = null;
  if (!summary?.is_running && summary.fail_count > 0) {
    button = <TextButton text='Retry' onPress={props.onRetry} />;
  } else if (!summary?.is_running) {
    button = <TextButton text='Close' onPress={_onClosePress} />;
  }

  const rows = list?.map?.((item) => [
    item.media_path,
    byteFormat(item.file_size),
    _statusText(item),
    _errorText(item.fatal_err || item.last_err) || '-',
  ]);
  return (
    <>
      <TitleActionLine title={`Download: ${status}`}>{button}</TitleActionLine>
      <StandardBoxList title='Summary'>
        <PropList
          columns={[
            [
              { label: 'Succeeded', value: success },
              { label: 'Skipped', value: skipped },
            ],
            [{ label: 'Failed', value: failure }],
          ]}
        />
      </StandardBoxList>
      <StandardBoxList
        title='Files'
        detail={detail}
        headers={['Name', 'Size', 'Status', 'Error']}
        sizes={[3, 1, 2, 1]}
        rows={rows}
      />
    </>
  );
}
function _statusText(item: Item): string {
  switch (item.status) {
    case 'waiting':
      return 'Waiting';
    case 'get_url':
      return 'Preparing for Download';
    case 'start_download':
      return 'Starting Download';
    case 'downloading':
      return (item.progress * 100).toFixed(2) + '%';
    case 'copying':
      return 'Copying';
    case 'done':
      return item.skip ? 'Skip' : 'Done';
    case 'error':
      return 'Error';
  }
  return '';
}
function _errorText(err): string {
  let ret = '';
  if (err === 'url_not_found') {
    ret = 'Not Uploaded';
  } else if (err) {
    ret = 'Download Failed';
  }
  return ret;
}
